// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapIcon, BootstrapImage } from '../../../dsl/front';
import { ImageRatio } from '../../_contracts';
import { prepareImage } from '../../_filters';
let Editor = class Editor extends Vue {
    /**
     * Determines icon name.
     */
    iconName(key) {
        return `${key}-fill`;
    }
    /**
     * Determines uniq link id.
     */
    linkId(index) {
        return `link-${index}`;
    }
    /**
     * Determines editor links.
     */
    get links() {
        const links = this.editor.links;
        if (!links) {
            return;
        }
        return Object.entries(links).filter(([key, value]) => !!value);
    }
    /**
     * Determines editor author
     * avatar image.
     *
     */
    get authorAvatar() {
        if (typeof this.editor === 'undefined' || typeof this.editor.avatar === 'undefined') {
            return;
        }
        return prepareImage(this.editor.avatar, ImageRatio.Square, 510, this.isLazy);
    }
};
__decorate([
    Prop({
        type: Object,
        required: true
    })
], Editor.prototype, "editor", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: 'h3'
    })
], Editor.prototype, "nameTag", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    })
], Editor.prototype, "isLazy", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    })
], Editor.prototype, "showAbout", void 0);
Editor = __decorate([
    Component({
        name: 'Editor',
        components: {
            BootstrapImage,
            BootstrapIcon
        },
        template: `
    <div class="editor row m-0">

    <div class="editor__avatar col-12 col-md-4 col-lg-2 mb-6 mb-md-0">
      <div class="editor__avatar__wrapper">
        <BootstrapImage v-if="authorAvatar" class="editor__avatar__image" v-bind="authorAvatar"/>
      </div>
    </div>

    <div class="editor__meta col-12 col-md-8 col-lg-4 ps-md-4">

      <component class="editor__meta__name h2 mb-2" :is="nameTag">
        {{ editor.firstName }} {{ editor.lastName }}
      </component>

      <p class="text-ui-separator text-uppercase mb-1">
        {{ editor.position }}
      </p>

      <p class="fs-medium fw-bold">
        {{ editor.email }}
      </p>

      <div v-if="links" class="editor__meta-links">
        <a
          v-for="([key, value], index) in links"
          :href="value"
          :key="linkId(index)"
          class="link"
        >
          <template v-if="key === 'twitter'">
            <BootstrapIcon name="x" size="small" class="bg-black text-white rounded"/>
          </template>
          <template v-else>
            <BootstrapIcon :name="iconName(key)" size="small"/>
          </template>
        </a>
      </div>
    </div>

    <div v-if="editor.description && showAbout" class="col-12 col-lg-6 fs-medium fw-md-bold mb-0"
         v-html="editor.description"/>
    </div>
  `
    })
], Editor);
export { Editor };
export default Editor;
